import React from 'react';
import { QuizQuestion } from '../types/quiz';

interface ExplanationProps {
  question: QuizQuestion;
  isCorrect: boolean;
}

export const Explanation: React.FC<ExplanationProps> = ({ question, isCorrect }) => {
  return (
    <div className="mt-6 space-y-4 animate-slide-up">
      <div
        className="p-4 rounded-lg border-2"
        style={{
          backgroundColor: isCorrect ? 'var(--wcag-success-bg)' : 'var(--wcag-danger-bg)',
          borderColor: isCorrect ? 'var(--wcag-success-border)' : 'var(--wcag-danger-border)',
        }}
      >
        <div className="flex items-start gap-3">
          <span className="text-3xl">{isCorrect ? '🎉' : '📚'}</span>
          <div>
            <h3
              className="font-bold text-lg mb-2"
              style={{ color: isCorrect ? 'var(--wcag-success-text)' : 'var(--wcag-danger-text)' }}
            >
              {isCorrect ? 'Bravo !' : 'Pas tout à fait...'}
            </h3>
            <p
              style={{ color: isCorrect ? 'var(--wcag-success-text)' : 'var(--wcag-danger-text)' }}
            >
              {question.explanation}
            </p>
          </div>
        </div>
      </div>

      <div
        className="p-4 rounded-lg border-2"
        style={{ backgroundColor: 'var(--wcag-info-bg)', borderColor: 'var(--wcag-info-border)' }}
      >
        <h4
          className="font-bold mb-3 flex items-center gap-2"
          style={{ color: 'var(--wcag-info-text)' }}
        >
          <span>💡</span>
          Conseils pour vous protéger :
        </h4>
        <ul className="space-y-2">
          {question.tips.map((tip, index) => (
            <li
              key={index}
              className="flex items-start gap-2"
              style={{ color: 'var(--wcag-info-text)' }}
            >
              <span className="mt-1" style={{ color: 'var(--wcag-info-text)' }}>
                •
              </span>
              <span>{tip}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
